import React from "react";
import { Page } from "../../components/Page";
import { DisconnectionInfo } from "../../components/DisconnectionInfo";

interface Props {
  tabTitle: string;
}

export const DisconnectionInfoPage: React.FC<Props> = ({ tabTitle }) => {
  return (
    <Page tabTitle={tabTitle}>
      <DisconnectionInfo />
    </Page>
  );
};
